module.exports = __webpack_public_path__ + "static/media/test1_4.aa5dd9ff.png";